import React from 'react';
import { Modal } from 'react-bootstrap';
import { isString } from 'lodash';

import { ModalInterface, ModalContextInterface } from './types';

// This context allows for easy control and rendering of a modal. Usage example:

// const { setModal } = useModalContext()

// To open a modal. You can pass a string or ReactNode as the `header`.
// setModal({body: <p>This would be the body</p>});
// setModal({body: <p>body</p>, header: 'Optional Title'})

// To close the modal
// setModal(null);

const ModalContext = React.createContext<ModalContextInterface | null>(null);

export const useModalContext = () => {
  const context = React.useContext(ModalContext) as ModalContextInterface;
  if (context === undefined) {
    throw new Error('You must wrap your page with <ModalProvider /> in order to useModalContext().');
  }
  return context;
};

export const ModalProvider: React.FC = ({ children }) => {
  const setModal = (modal: ModalInterface) => {
   setData({...data, modal});
  };

  const [data, setData] = React.useState({ modal: null });

  return (
    <ModalContext.Provider value={{ setModal }}>
      {children}

      <Modal show={!!data.modal} onHide={() => setModal(null)}>
        {
          data.modal && data.modal.header
          ? <Modal.Header className="u-border-A-n u-padding-H-l" closeButton>
              {isString(data.modal.header) ? <h3><strong>{data.modal.header}</strong></h3> : data.modal.header}
            </Modal.Header>
          : null
        }
        <Modal.Body className="u-padding-T-n">
          {data.modal && data.modal.body}
        </Modal.Body>
      </Modal>
    </ModalContext.Provider>
  );
};
